import { useState } from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarFooter,
  SidebarHeader,
  SidebarContent,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link } from "react-router-dom";
import "./SideBar.css";

function Sidebar() {
  const [showSideBar, setShowSideBar] = useState(false);

  return (
    <ProSidebar className="side-bar" collapsed={showSideBar}>
      <SidebarHeader className="my-5"></SidebarHeader>
      <SidebarContent>
        <Menu iconShape="circle">
          <MenuItem icon={<i className="bi bi-clipboard-data-fill"></i>}>
            <Link to="/">Dashboard</Link>
          </MenuItem>
          <MenuItem
            className="my-3"
            icon={<i className="fs-5 bi bi-person-circle"></i>}
          >
            <Link to="/admins">Admins</Link>
          </MenuItem>
          <MenuItem
            className="my-3"
            icon={<i className="fs-5 bi bi-card-list"></i>}
          >
            <Link to="/categories">Categories</Link>
          </MenuItem>
          <MenuItem
            className="my-3"
            icon={<i className="fs-5 bi bi-person-workspace"></i>}
          >
            <Link to="/customers">Customers</Link>
          </MenuItem>
          <MenuItem
            className="my-3"
            icon={<i className="fs-5 bi bi-receipt-cutoff"></i>}
          >
            <Link to="/orders">Orders</Link>
          </MenuItem>
          <MenuItem
            className="my-3"
            icon={<i className="fs-5 bi bi-gift-fill"></i>}
          >
            <Link to="/products">Products</Link>
          </MenuItem>
          <MenuItem icon={<i className="bi bi-info-square-fill"></i>}>
            <Link to="/about-this-project">About this project</Link>
          </MenuItem>

          {/*           <SubMenu title="Components" icon={<i className="bi bi-alarm-fill"></i>}>
            </SubMenu> */}
        </Menu>
      </SidebarContent>
      <SidebarFooter>
        <div
          className="d-flex justify-content-center"
          onClick={() => setShowSideBar(!showSideBar)}
        >
          {showSideBar ? (
            <i className="bi bi-toggle-off fs-4 py-3"></i>
          ) : (
            <i className="bi bi-toggle-on fs-4 py-3"></i>
          )}
        </div>
      </SidebarFooter>
    </ProSidebar>
  );
}

export default Sidebar;
